<template>
  <div>
    <div class="background-image">
      <el-col  :offset="8" :span="8" style="margin-top: 30px">
        <h2 style="color: white;font-size: 30px">我们是一个开放的论文解决社区方案</h2>
      </el-col>
      <el-col  :offset="6" :span="10">
        <h2 style="color: white;font-size: 20px">每一位论文解决方案er都能贡献和更新技术内容，共同参与社区建设，维护社区秩序</h2>
        <h2 style="color: white;font-size: 20px">如果你和我们一样有论文解决方案理想，并愿意贡献自己的力量，欢迎加入我们</h2>
      </el-col>
    </div>
    <div style="margin-top: -40px">
      <el-row :gutter="10" type="flex" >
        <el-col :span="3" :offset="3">
          <el-card shadow="always" style="text-align:center" >
            <img  width="70" height="50" src="@/public/img/v-1.svg" style="vertical-align:middle;">
            <span style="font-size: 22px;vertical-align:middle;text-align:center"  >问答 </span>
          </el-card>
        </el-col>
        <el-col :span="3">
          <el-card shadow="always" style="text-align:center">
            <img  width="70" height="50" src="@/public/img/v-2.svg" style="vertical-align:middle">
            <span style="font-size: 22px"  >专栏 </span>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="always" style="text-align:center">
            <img  width="70" height="50" src="@/public/img/v-3.svg" style="vertical-align:middle" >
            <span style="font-size: 22px"  >解决方案 </span>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="always" style="text-align:center">
            <img  width="70" height="50" src="@/public/img/v-4.svg" style="vertical-align:middle">
            <span style="font-size: 22px"  >知网免费查重 </span>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card shadow="always" style="text-align:center;cursor: pointer"  @click.native="goDown">
            <img  width="70" height="50" src="@/public/img/v-5.svg" style="vertical-align:middle">
            <span style="font-size: 22px"  >资料免费下载</span>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="4"  style="margin-top: 25px">
        <el-col :span="6" :offset="3">
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <h4 style="vertical-align: middle">精彩内容</h4>
            </div>

            <el-link type="success" style="text-align: center" @click.native="goT">基于Java的商城网站系统设计与实现+源码下载</el-link>
            <el-divider></el-divider>
            <el-link type="success">基于Java的商城网站系统设计与实现</el-link>
            <el-divider></el-divider>
            <el-link type="success">基于Java的商城网站系统设计与实现</el-link>
            <el-divider></el-divider>
            <el-link type="success">基于Java的商城网站系统设计与实现</el-link>

          </el-card>
        </el-col>

        <el-col :offset="1" :span="14" >
          <el-row v-for="items in articles" style="margin-bottom: 25px">

            <el-col :span="10" v-for="item in items" >

              <div style="position: relative;">

                <img
                    style="width: 90px; height: 80px"
                    src="@/public/img/v-6.svg"
                >
                <span  style="position: absolute; left: 90px">{{item.Name}}</span>

                <el-link type="primary" :underline="false" style="position: absolute; left: 90px;top: 50px" icon="el-icon-user">
                  {{item.Author}}</el-link>
                <span style="position: absolute; right: 80px;top: 50px">{{formatDate(item.CreatedAt)}}</span>

              </div>

            </el-col>

          </el-row>



        </el-col>


      </el-row>


    </div>
  </div>

</template>

<script>
import http from '../utils/http-base'
export default {
  name: "index-home",
  data(){
    return{
      articles:[]
    }

  },
  methods:{
    goT(){
      console.log(123)
      window.open('/down/java_shop-master.zip', '_blank');

    },
    goDown(){
      console.log(this.$store.state.name,123)
      if (this.$store.state.name){
        this.$router.push({
          name:'down',
        })
      }else{
        this.$message.error("请先登录系统!")
      }

    },
    getArticle() {
      http.get("/api/article/index",).then(res=>{
        if (res.data.code ===0){
          this.articles=res.data.data
        }
      })
    },
    formatDate(sDate) {
      // 将RFC3339字符串转换为JavaScript Date对象
      const date = new Date(sDate);
      // 使用Date对象的方法格式化日期
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // getMonth() 返回的月份是从 0 开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

      // 根据本地格式显示日期
    }
  },
  mounted() {
    // 页面打开时需要执行的操作
    this.getArticle();
  },
}
</script>

<style scoped>

.background-image {
  height: 350px;          /* 设置div的高度 */
  background-image: url('@/public/img/b8.jpg'); /* 设置背景图片 */
  background-size: cover; /* 背景图片覆盖整个div区域 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
}
</style>